<script setup lang="ts">
import { remoteImageStaticUrl } from "common/utils/remote-image";

const list = [
  {
    title: "Original",
    imageName: "original"
  },
  {
    title: "Sharpened",
    imageName: "sharpened"
  },
  {
    title: "Background Removed",
    imageName: "background_removed"
  },
  {
    title: "Color Changes",
    imageName: "color_changes"
  },
  {
    title: "Elements Removed",
    imageName: "elements_removed"
  },
  {
    title: "Text Changes",
    imageName: "text_changes"
  }
];
const computedImageUrl = (imageName: string) =>
  remoteImageStaticUrl(`gen/expert_edit_illustration_1/${imageName}.png`);
</script>

<template>
  <div class="custom-comparison">
    <h2 class="custom-comparison__header">Illustrative Example</h2>

    <div class="custom-comparison__body">
      <div v-for="item in list" :key="item.title" class="custom-comparison__item">
        <h3 class="custom-comparison__item-title">{{ item.title }}</h3>

        <div
          class="custom-comparison__item-image-wrapper"
          :class="`custom-comparison__item-image-wrapper--${item.imageName}`"
        >
          <img
            :alt="`Illustration for ${item.title}`"
            class="custom-comparison__item-image"
            :src="computedImageUrl(item.imageName)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "frontend/init/jiffy/settings";
@import "frontend/init/jiffy/mixin";
@import "../ArtworkQualityConfigPanel.scss";

.custom-comparison {
  width: 100%;

  &__header {
    font-size: 16px;
    font-weight: 700;
    line-height: 25px;
    margin: 0 0 16px;
    color: $mirage;
    text-align: center;
  }

  &__body {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 12px;
    row-gap: 10px;

    @include with-medium-container {
      column-gap: 16px;
      row-gap: 12px;
      grid-template-columns: repeat(3, 1fr);
    }
  }

  &__item-title {
    color: $app-gray-modern-800;
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    margin: 0 0 2px;

    @include with-medium-container {
      font-size: 14px;
    }
  }

  &__item-image-wrapper {
    position: relative;
    padding-top: 100%;
    overflow: hidden;
    border-radius: 8px;
    background: $enhance-gradient-horizontal;
    box-shadow: 0 0 15.8px 1px rgba(239, 65, 244, 0.31);

    &--original {
      background: transparent;
      box-shadow: none;
    }
  }

  &__item-image {
    position: absolute;
    inset: 2px;
    object-fit: cover;
    width: calc(100% - 4px);
    height: calc(100% - 4px);
    border-radius: 5px;
    background: $white;

    @include with-medium-container {
      inset: 3px;
      width: calc(100% - 6px);
      height: calc(100% - 6px);
    }
  }
}
</style>
